import React from "react";
import { ProjectList } from "../../../data/ProjectData";
import {
  Card,
  CardLeft,
  CardRight,
  BtnGroup,
  TechCardContainer,
  TechCard,
} from "./ProjectCardElements";
import ScrollAnimation from "react-animate-on-scroll";
function ProjectCard() {
  return (
    <>
      {ProjectList.map((list, index) => (
        <ScrollAnimation animateIn="fadeInLeft" key={index}>
          <Card>
            <CardLeft>
              <img
                style={{
                  objectFit: index === 3 ? "contain" : "cover",
                }}
                src={list.img}
                alt={list.name}
                height={index === 3 ? 500 : "auto"}
              />
            </CardLeft>
            <CardRight>
              <h4>{list.title}</h4>
              <p style={{ whiteSpace: "pre-line" }}>{list.description}</p>
              {/* <TechCardContainer>
                {list?.tech_stack?.map((tech, index) => (
                  <TechCard key={index}>{tech}</TechCard>
                ))}
              </TechCardContainer> */}
              <BtnGroup>
                {list?.github_url?.length > 0 && (
                  <a
                    className="btn SecondaryBtn btn-shadow"
                    href={list?.github_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Github
                  </a>
                )}
                {(list.title === "CareAsOne" ||
                  list.title === "OMoney Capital" ||
                  list.title === "Tasty Bites") && (
                  <a
                    className="btn PrimaryBtn btn-shadow"
                    href={list.demo_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Live Preview ➜
                  </a>
                )}
                {list?.download_url?.length > 0 && (
                  <a
                    className="btn PrimaryBtn btn-shadow"
                    href={list.download_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                  >
                    Download Android App ➜
                  </a>
                )}
              </BtnGroup>
            </CardRight>
          </Card>
        </ScrollAnimation>
      ))}
    </>
  );
}

export default ProjectCard;
